import React, { useState, useRef, useMemo, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import {manage_call_result, create_maintenance_document, get_images_by_maintenance, get_documents_by_maintenance} from "../api/api";

import ConfirmModal from './ConfirmModal';
import MaintenanceModal from './MaintenanceModal';
import MaintenanceDetailModal from './MaintenanceDetailModal';
import AddDocumentModal from './AddDocumentModal';
import TransactionModal from './TransactionModal';
import icon_pen from '../img/icon_pen.png';
import icon_trash from '../img/icon_trash.png';
import icon_eye from '../img/icon_eye.png';
import icon_search from '../img/icon_search.png';
import icon_download from '../img/icon_download.png';
import icon_map_mode_1 from '../img/icon_mapmode1.png';
import icon_map_mode_2 from '../img/icon_mapmode2.png';
import icon_qr from '../img/icon_qr.png';

ModuleRegistry.registerModules([AllCommunityModule]);

const DynamicTable = ({
  items,
  objectName,
  documentType = null,
  rockfall_id = null,
  hasMap = false,
  callbackShowMap,
  callbackHideMap,
  createFunction,
  updateFunction,
  deleteFunction,
  getColumnDefs,
  newRowTemplate,
  columnKey,
  callbackMapClickability,
  openMapForCoords = null,
  closeMapForCoords = null,
  eyeIconCallback = null,
  onRowSelect = function(){},
  selectedCoords = null,
  customAddElelentModal = false,
  customDetailModal = false,
  user_id = null,
  showEditButton = true,
  showDownloadButton = false,
  showTransactionModal = false,
  isAddButtonForDocument = false,
  users
}) => {
  const gridRef = useRef();


  const [rowData, setRowData] = useState(items);
  const [editingRow, setEditingRow] = useState(null);

  const [recordToDelete, setRecordToDelete] = useState(-1);
  const [recordRowIdToDelete, setRecordRowIdToDelete] = useState(-1);
  const [showAddDocumentModal, setShowAddDocumentModal] = useState(false);
  const [showCustomAddElementModal, setShowCustomAddElementModal] = useState(false);
  const [showCustomDetailModal, setShowCustomDetailModal] = useState(false);
  const [maintenanceImageList, setMaintenanceImageList] = useState([]);
  const [maintenanceDescription, setMaintenanceDescription] = useState([]);
  const [maintenanceDocumentList, setMaintenanceDocumentList] = useState([]);
  const [transactionData, setTransactionData] = useState(null);

  const role = localStorage.getItem('role');

  const canAdd = (role === 'Intermediate' && isAddButtonForDocument) || role === 'Advanced' || role === 'Admin';
  const canEdit = role === 'Advanced' || role === 'Admin';


  const resetEditor = async (gridApi, editingRow, setEditingRow) => {
    const focusedCell = gridApi.getFocusedCell();
    if (!focusedCell) return;

    await gridApi.stopEditing();
    await gridApi.startEditingCell({
      rowIndex: focusedCell.rowIndex,
      colKey: focusedCell.column.getColId(),
    });

    setTimeout(() => {
      setEditingRow(editingRow);
      setActionButtons();
      document.querySelectorAll(`.edit-icon`).forEach(e => (e.style.display = 'none'));

    }, 100);
  };


  useEffect(() => {
    if(gridRef && gridRef.current && gridRef.current.api){
      resetEditor(gridRef.current.api, editingRow, setEditingRow);
    }
  }, [selectedCoords]);

  useEffect(() => {
    setRowData(items);
  }, [items]);


  const setActionButtons = () =>{
    if (gridRef.current && gridRef.current.api) {
      if (editingRow !== null && editingRow !== -1 && typeof editingRow !== 'undefined') {
        document.querySelectorAll(`.edit-icon-${editingRow}`).forEach(e => (e.style.display = 'none'));
        document.querySelectorAll(`.save-edit-button-${editingRow}`).forEach(e => (e.style.display = 'inline-block'));
        document.querySelectorAll(`.cancel-edit-button-${editingRow}`).forEach(e => (e.style.display = 'inline-block'));
      } else {
        document.querySelectorAll('.edit-icon').forEach(e => (e.style.display = 'inline-block'));
        document.querySelectorAll('.save-edit-button').forEach(e => (e.style.display = 'none'));
        document.querySelectorAll('.cancel-edit-button').forEach(e => (e.style.display = 'none'));
      }
    }

  }

  useEffect(() => {
    setActionButtons();
  }, [editingRow]);

  const goToDetail = (item_id) => {
    //const rowNode = gridRef.current.api.getRowNode(rowId);
    //const itemId = rowNode.data.id;
    eyeIconCallback(`/protection/${item_id}`)
    //navigate(`/protection/${itemId}`);
  };

  const handleDeleteConfirm = async (item_id) => {
   /* const rowNode = gridRef.current.api.getRowNode(rowId);
    const rowData = rowNode.data;
    const res = await deleteFunction(rowData.id);*/
    const res = await deleteFunction(item_id);
    const ok = manage_call_result(res);
    setRecordToDelete(-1);

    if(ok){
      deleteRow(recordRowIdToDelete);
      setRecordRowIdToDelete(-1);

    }
  };

  const handleDeleteCancel = () => setRecordToDelete(-1);


  const downloadDocument = (rowIndex, item_id) => {
    const rowNode = gridRef.current.api.getRowNode(rowIndex);
    const rowData = rowNode.data;
    if(rowData && rowData.document){
      const filename = rowData.document.split('/').pop();
      const newWindow = window.open("/media/"+filename, "_blank");
      if (newWindow) newWindow.opener = null;
    }
  }


  const startEditing = (rowIndex, item_id) => {

    console.log("ere");
    if(callbackMapClickability) callbackMapClickability(true);

    //disable all edit buttons!
    document.querySelectorAll(`.edit-icon`).forEach(e => (e.style.display = 'none'));

    if (hasMap) setMapMode1();
    console.log(item_id);

    setEditingRow(item_id);
    setTimeout(() => {
      gridRef.current.api.startEditingCell({ rowIndex, colKey: columnKey });
    }, 50);
  };


  const cancelEditing = () => {
    if(callbackMapClickability) callbackMapClickability(false);
    gridRef.current.api.stopEditing(true); // Cancel editing
    setEditingRow(null);
  };


  const handleStopEditing = async (event) => {

    console.log(event);

    //horrible check, but it works
    //avoids triggering save when refreshing table for external coord select on the map

    if(document.querySelector("#the_map_container") && document.querySelector("#the_map_container").style.display !== 'none'){
      return;
    }

    const json_data = event.data;
    console.log("handleStopEditing");
    console.log(json_data);
    const the_id = json_data.id;
    let ok = true;

    if (json_data.create) {
      const res = await createFunction(json_data);



      ok = manage_call_result(res);
      if (res?.data?.id) {
        const newId = res.data.id;
        setRowData((prev) =>
          prev.map((row) =>
            row.id === the_id ? { ...row, id: newId, create: undefined } : row
          )
        );
        setEditingRow(null);
      }
    } else {
      const res = await updateFunction(the_id, json_data);
      ok = manage_call_result(res);
      setEditingRow(null);
    }

    if (!ok) {
      startEditing(0, 0);
    }
  };

  const stopEditing = () => {
    //reenable all edit buttons!
    if(callbackMapClickability) callbackMapClickability(false);
    document.querySelectorAll(`.edit-icon`).forEach(e => (e.style.display = 'inline-block'));
    if (gridRef.current) gridRef.current.api.stopEditing();
  };

  const deleteRow = (rowId) => {
    console.log("row id being deleted");
    console.log(rowId);
    const rowNode = gridRef.current.api.getRowNode(rowId);
    const rowData = rowNode.data;
    gridRef.current.api.applyTransaction({ remove: [rowData] });
    setRowData((prev) => prev.filter((row) => row.id !== rowData.id));
  };

  const setMapMode1 = () => {
    document.getElementById('dynamic-table-mode-1')?.classList.add('active');
    document.getElementById('dynamic-table-mode-2')?.classList.remove('active');
    gridRef.current.api.setColumnsVisible(['mel_energy', 'dimensions', 'installation_year', 'revision_year', 'typology', 'mel_energy', 'description'], true);
    callbackHideMap?.();
  };

  const setMapMode2 = () => {
    document.getElementById('dynamic-table-mode-2')?.classList.add('active');
    document.getElementById('dynamic-table-mode-1')?.classList.remove('active');
    gridRef.current.api.setColumnsVisible(['mel_energy', 'dimensions', 'installation_year', 'revision_year', 'typology', 'mel_energy', 'description'], false);
    callbackShowMap?.();
  };

  const onFilterTextBoxChanged = () => {
    gridRef.current.api.setGridOption('quickFilterText', document.getElementById('filter-text-box').value);
  };

  const addNewRow = () => {

    if(customAddElelentModal!==false){
       setShowCustomAddElementModal(true);
       return;
    }
    if(documentType!==null)
    {
       setShowAddDocumentModal(true);
    }
    else{
      const newRow = { ...newRowTemplate, id: 0, create: true };
      setRowData((prev) => [newRow, ...prev]);
      if (hasMap) setMapMode1();
      setTimeout(() => startEditing(0, 0), 100);
    }

  };


  const handleAddDocument = async (data)=>{
    const newRow = { ...newRowTemplate, id: 0, create: true };
    newRow.name = data.name;

    const the_id = 0;
    let ok = true;

    var today = new Date()


    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('document_date', today.toISOString().split('T')[0]);
    formData.append('document', data.file);
    formData.append('category', documentType);
    formData.append('rockfall', rockfall_id);


    const res = await createFunction(formData);
    if (res?.data?.id) {
      newRow.document =  res.data.document;
      const newId = res.data.id;
      //res.data.document
      setRowData((prev) =>
        prev.map((row) =>
          row.id === the_id ? { ...row, id: newId, create: undefined } : row
        )
      );
      setEditingRow(null);
      setRowData((prev) => [newRow, ...prev]);
    }

    setShowAddDocumentModal(false);
    //if (hasMap) setMapMode1();
    //setTimeout(() => startEditing(0, 0), 100);
  }

  const handleAddMaintenanceDocument = async (data)=>{


    var newRow = { ...newRowTemplate, id: 0, create: true };
    newRow.name = data.name;
    const the_id = 0;
    let ok = true;

    var today = new Date()

    var the_ts = Math.floor(today.getTime() / 1000);
    var the_date = today.toISOString().split('T')[0];

    const json_data = {};
    json_data["name"] =  "intervento_"+the_ts;
    json_data["date"] =  the_date;
    json_data["rockfall"] = rockfall_id;
    json_data["user"] = user_id;
    json_data["category"] = data.category;
    newRow = json_data;


    const res = await createFunction(json_data);

    var newId = null;
    if (res?.data?.id) {
      newId = res.data.id;
      newRow["id"] = newId;
      setRowData((prev) =>
        prev.map((row) => {
          console.log("ROW: ");
          console.log(row.id+" "+the_id+" ");
          return (!row.id || row.id === the_id) ? { ...row, id: newId, create: undefined } : row
        }
        )
      );
      setEditingRow(null);
      setRowData((prev) => [newRow, ...prev]);
    }


    if(data && data.files){
      for(var i=0; i<data.files.length; i++){

          var the_file = data.files[i];
          // SAVE SINGLE FILES:
          const formData2 = new FormData();

          formData2.append('document', the_file);
          formData2.append('name', the_file.name);
          formData2.append('document_date', the_date);
          formData2.append('maintenance', newId);

          const res2 = create_maintenance_document(formData2);
          manage_call_result(res2);
      }
    }

    setShowCustomAddElementModal(false);
    //if (hasMap) setMapMode1();
    //setTimeout(() => startEditing(0, 0), 100);
  }


  const openTransactionModal = (data) => {
      console.log("WHAAAt");
      console.log(data);
      setTransactionData(data);
  }



  const loadAndShowDescriptionDocumentsAndImages = async (desc,id) => {


    console.log("loading images for "+id);
    var res = await get_images_by_maintenance(id);


    console.log(res);

    var theImageList = [];
    if(res && res.success){
      var results = res.data.results;
      results.forEach((r)=>{
        var imagedata = r.content;
        //theImageList.push("data:image/png;base64,"+imagedata);
        theImageList.push(imagedata);
      });
    }
    setMaintenanceImageList(theImageList);
    setMaintenanceDescription(desc);


    console.log("loading docuemnts for "+id);
    var res2 = await get_documents_by_maintenance(id);
    console.log(res2);


    var theDocumentList = [];
    if(res2 && res2.success){
      var results2 = res2.data.results;
      results2.forEach((r)=>{
        theDocumentList.push(r);
      });
    }

    setMaintenanceDocumentList(theDocumentList);


    setShowCustomDetailModal(true);

  }

  const handleCellClick = (event) => {
    if (event.colDef.field !== 'actions') {
      //event.api.selectNode(event.node, true);
      onRowSelect(event.data);
    }
  };


  const rowClassRules = useMemo(() => ({ 'pointer-events-none': () => false }), []);

  const getMergedColumnDefs = () => ([
    ...getColumnDefs(startEditing, stopEditing, setRecordToDelete, goToDetail, users),
    {
      headerName: 'Azioni',
      field: 'actions',
      cellRenderer: (params) => {
        const { startEditing, stopEditing, setRecordToDelete, goToDetail } = params.context;
        const id = params.data.id;
        const rowIndex = params.node.rowIndex;

        return (
          <div>
            { showEditButton && canEdit && <img alt="icon_pen" src={icon_pen} className={`edit-icon edit-icon-${id}`} onClick={() => startEditing(rowIndex, id)} style={{ width: '38px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { showDownloadButton && <img alt="icon_download" src={icon_download} className={`edit-icon edit-icon-${id}`} onClick={() => downloadDocument(rowIndex, id)} style={{ width: '38px', cursor: 'pointer', padding: '4px 8px' }} /> }

            { canEdit && <img alt="icon_trash" src={icon_trash} className={`edit-icon edit-icon-${id}`} onClick={() => {setRecordToDelete(id); setRecordRowIdToDelete(rowIndex)}} style={{ width: '34px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { eyeIconCallback && <img alt="icon_eye" src={icon_eye} className={`edit-icon edit-icon-${id}`} onClick={() => goToDetail(id)} style={{ width: '37px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { customDetailModal && <img alt="icon_eye" src={icon_eye} className={`edit-icon edit-icon-${id}`} onClick={() => loadAndShowDescriptionDocumentsAndImages(params.data.description, id)} style={{ width: '37px', cursor: 'pointer', padding: '4px 8px' }} /> }
            { showTransactionModal && <img alt="icon_qr" src={icon_qr} className={`edit-icon edit-icon-${id}`}  onClick={() => openTransactionModal(params.data)} style={{ width: '37px', cursor: 'pointer', padding: '4px 8px' }} /> }

            <button className={`save-edit-button save-edit-button-${id}`} onClick={stopEditing} style={{ display: 'none', cursor: 'pointer', padding: '4px 8px' }}>Salva</button>
            <button className={`cancel-edit-button cancel-edit-button-${id}`} onClick={cancelEditing} style={{ display: 'none', cursor: 'pointer', padding: '4px 8px' }}>Annulla</button>
          </div>
        );
      },
      editable: false,
      sortable: false
    }
  ]);


  return (
    <div className="dynamic-table-inner">
      <div className="dynamic-table-topbar">
        <div className="dynamic-table-topbar-left">

          <img className="icon-search" src={icon_search} alt="search" />
          <input type="text" id="filter-text-box" className="filter-text-box" onInput={onFilterTextBoxChanged} />
        </div>
        <div className="dynamic-table-topbar-right">
          {hasMap && (
            <>
              <button className="toggle-button" onClick={setMapMode1}>
                <img src={icon_map_mode_1} id="dynamic-table-mode-1" className="dynamic-table-mode active" alt="map mode 1" />
              </button>
              <button className="toggle-button" onClick={setMapMode2}>
                <img src={icon_map_mode_2} id="dynamic-table-mode-2" className="dynamic-table-mode" alt="map mode 2" />
              </button>
            </>
          )}
          { canAdd && (<button className="dynamic-table-add-new" onClick={addNewRow} disabled={editingRow !== null && editingRow !== -1 && typeof editingRow !== 'undefined'}>
            Aggiungi {objectName}
          </button>
          )}
        </div>
      </div>

      <div style={{ height: 'calc(83vh - 105px)' }}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          context={{ startEditing, stopEditing, deleteRow, setRecordToDelete, setRecordRowIdToDelete, goToDetail, editingRow, openMapForCoords, closeMapForCoords, selectedCoords }}
          gridOptions={{
            editType: 'fullRow',
            columnDefs: getMergedColumnDefs(),
            onRowEditingStopped: handleStopEditing,
            rowClassRules: { rowClassRules },
            pagination: true,
            rowHeight: 60,
            paginationPageSize: 10,
            paginationPageSizeSelector: [10, 20, 50, 100],
            suppressClickEdit: true,
            onCellClicked: handleCellClick,
          }}
        />
      </div>

      {recordToDelete !== -1 && (
        <ConfirmModal
          message={`Eliminare il record?`}
          onConfirm={() => handleDeleteConfirm(recordToDelete)}
          onCancel={handleDeleteCancel}
        />
      )}


      {showAddDocumentModal && (

        <AddDocumentModal
          onConfirm={(data) => handleAddDocument(data)}
          onCancel={()=>{setShowAddDocumentModal(false)}}
        />
      )}


      {showCustomAddElementModal && (

        <MaintenanceModal
          onConfirm={(data) => handleAddMaintenanceDocument(data)}
          onCancel={()=>{setShowCustomAddElementModal(false)}}
        />
      )}

      {showCustomDetailModal && (

        <MaintenanceDetailModal
          description={maintenanceDescription}
          imageList={maintenanceImageList}
          documentList={maintenanceDocumentList}
          onCancel={()=>{setShowCustomDetailModal(false)}}
        />
      )}

      {transactionData && (
         <TransactionModal
          data={transactionData}
          onCancel={()=>{setTransactionData(false)}}
        />
      )}


    </div>
  );
};

export default DynamicTable;
